import { makeStyles } from '@mui/styles';
import { theme } from '../../theme/Theme';

export const useStyles = makeStyles({
  customButtonContainer: {
    display: 'flex',
    marginTop: 24,
    marginBottom: 24,
  },
  activeButton: {
    color: theme.colors.light,
    backgroundColor: theme.colors.buttonPrimary,
    height: '35px',
    minWidth: '100px',
    textTransform: 'capitalize',
    marginRight: '5px',
    '&:hover': {
      backgroundColor: theme.colors.buttonPrimary,
    },
  },
  inactiveButton: {
    color: theme.colors.label,
    height: '35px',
    minWidth: '100px',
    marginRight: '5px',
    textTransform: 'capitalize',
  },
});
